import { render, staticRenderFns } from "./ShowDispatchRequestMetadata.vue?vue&type=template&id=3c3cde2c&"
import script from "./ShowDispatchRequestMetadata.vue?vue&type=script&lang=js&"
export * from "./ShowDispatchRequestMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports